const ChannelContent = () => {
  return (
    <>
      <div className=" display-max">
        <div className=" w-100">
          <div className=" w-60 mx-auto justify-content-center">
            <div className=" p-2 mt-2 text-center">
              <span className=" badge badge-md text-black border border-radius-2xl bg-light fw-bolder text-xs text-capitalize">
                Sun 31 Aug 2025
              </span>
            </div>
            <div className="card border border-radius-2xl mb-3">
              <div className="card-body py-3 px-2">
                <p className="mb-1 text-sm text-black">
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Quae, blanditiis voluptatem. Aspernatur quo dolorem quisquam
                  laborum, ullam necessitatibus pariatur veritatis natus ipsa
                  eaque enim et tempora recusandae temporibus nobis. Dolorum?
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Quae, blanditiis voluptatem. Aspernatur quo dolorem quisquam
                  laborum, ullam necessitatibus pariatur veritatis natus ipsa
                  eaque enim et tempora recusandae temporibus nobis. Dolorum?
                </p>
                <div className="d-flex align-items-center text-end text-black justify-content-end text-sm opacity-6">
                  <i className="bi bi-check2-all text-sm me-1"></i>
                  <small>3:14am</small>
                </div>
              </div>
            </div>
            <div className=" p-2 mt-2 text-center">
              <span className=" badge badge-md text-black border border-radius-2xl bg-light fw-bolder text-xs text-capitalize">
                Mon 01 Sep 2025
              </span>
            </div>
            <div className="card border border-radius-2xl mb-3">
              <div className="card-body py-3 px-2">
                <p className="mb-1 text-sm text-black">
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Quae, blanditiis voluptatem. Aspernatur quo dolorem quisquam
                  laborum, ullam necessitatibus pariatur veritatis natus ipsa
                  eaque enim et tempora recusandae temporibus nobis. Dolorum?
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Quae,
                </p>
                <div className="d-flex align-items-center text-end text-black justify-content-end text-sm opacity-6">
                  <i className="bi bi-check2-all text-sm me-1"></i>
                  <small>3:14am</small>
                </div>
              </div>
            </div>
            <div className="card border border-radius-2xl mb-3">
              <div className="card-header p-2 position-relative z-index-1">
                <div className="d-block">
                  <img
                    src="../../assets/img/stores/store-offers.jpeg"
                    className="img-fluid border-radius-lg"
                    alt=""
                  />
                </div>
              </div>
              <div className="card-body pt-2">
                <p className="mb-1 text-sm text-black">
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Quae, blanditiis voluptatem. Aspernatur quo dolorem quisquam
                  laborum.
                </p>
                <div className="d-flex align-items-center text-end text-black justify-content-end text-sm opacity-6">
                  <small>3:14am</small>
                </div>
              </div>
            </div>
            <div className=" p-2 mt-2 text-center">
              <span className=" badge badge-md text-black border border-radius-2xl bg-light fw-bolder text-xs text-capitalize">
                Tue 02 Sep 2025
              </span>
            </div>
            <div className="card border border-radius-2xl mb-3">
              <div className="card-body py-3 px-2">
                <p className="mb-1 text-sm text-black">
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Quae, blanditiis voluptatem. Aspernatur quo dolorem quisquam
                  laborum.
                </p>
                <div className="d-flex align-items-center text-end text-black justify-content-end text-sm opacity-6">
                  <i className="bi bi-check2-all text-sm me-1"></i>
                  <small>3:14am</small>
                </div>
              </div>
            </div>
            <div className="card border border-radius-2xl mb-3">
              <div className="card-body py-3 px-2">
                <p className="mb-1 text-sm text-black">
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Quae, blanditiis voluptatem. Aspernatur quo dolorem quisquam
                  laborum.
                </p>
                <div className="d-flex align-items-center text-end text-black justify-content-end text-sm opacity-6">
                  <small>3:14am</small>
                </div>
              </div>
            </div>
            <div className="card border border-radius-2xl mb-3">
              <div className="card-header p-2 position-relative z-index-1">
                <div className="d-block">
                  <img
                    src="../../assets/img/stores/store-offers-2.jpeg"
                    className="img-fluid border-radius-lg"
                    alt=""
                  />
                </div>
              </div>
              <div className="card-body pt-2">
                <p className="mb-1 text-sm text-black">
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Quae, blanditiis voluptatem. Aspernatur quo dolorem quisquam
                  laborum.
                </p>
                <div className="d-flex align-items-center text-end text-black justify-content-end text-sm opacity-6">
                  <small>3:14am</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" display-mini display-mob">
        <div className=" pt-6 w-97 mx-auto">
          <div className=" p-2 mt-2 text-center">
            <span className=" badge badge-md text-black border border-radius-2xl bg-light fw-bolder text-xs text-capitalize">
              Sun 31 Aug 2025
            </span>
          </div>
          <div className="card border border-radius-2xl mb-3">
            <div className="card-body py-3 px-2">
              <p className="mb-1 text-sm text-black">
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quae,
                blanditiis voluptatem. Aspernatur quo dolorem quisquam laborum,
                ullam necessitatibus pariatur veritatis natus ipsa eaque enim et
                tempora recusandae temporibus nobis. Dolorum? Lorem ipsum dolor
                sit amet consectetur, adipisicing elit. Quae, blanditiis
                voluptatem. Aspernatur quo dolorem quisquam laborum, ullam
                necessitatibus pariatur veritatis natus ipsa eaque enim et
                tempora recusandae temporibus nobis. Dolorum?
              </p>
              <div className="d-flex align-items-center text-end text-black justify-content-end text-sm opacity-6">
                <i className="bi bi-check2-all text-sm me-1"></i>
                <small>3:14am</small>
              </div>
            </div>
          </div>
          <div className=" p-2 mt-2 text-center">
            <span className=" badge badge-md text-black border border-radius-2xl bg-light fw-bolder text-xs text-capitalize">
              Mon 01 Sep 2025
            </span>
          </div>
          <div className="card border border-radius-2xl mb-3">
            <div className="card-body py-3 px-2">
              <p className="mb-1 text-sm text-black">
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quae,
                blanditiis voluptatem. Aspernatur quo dolorem quisquam laborum,
                ullam necessitatibus pariatur veritatis natus ipsa eaque enim et
                tempora recusandae temporibus nobis. Dolorum? Lorem ipsum dolor
                sit amet consectetur, adipisicing elit. Quae,
              </p>
              <div className="d-flex align-items-center text-end text-black justify-content-end text-sm opacity-6">
                <i className="bi bi-check2-all text-sm me-1"></i>
                <small>3:14am</small>
              </div>
            </div>
          </div>
          <div className="card border border-radius-2xl mb-3">
            <div className="card-header p-2 position-relative z-index-1">
              <div className="d-block">
                <img
                  src="../../assets/img/stores/store-offers.jpeg"
                  className="img-fluid border-radius-lg"
                  alt=""
                />
              </div>
            </div>
            <div className="card-body pt-2">
              <p className="mb-1 text-sm text-black">
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quae,
                blanditiis voluptatem. Aspernatur quo dolorem quisquam laborum.
              </p>
              <div className="d-flex align-items-center text-end text-black justify-content-end text-sm opacity-6">
                <small>3:14am</small>
              </div>
            </div>
          </div>
          <div className=" p-2 mt-2 text-center">
            <span className=" badge badge-md text-black border border-radius-2xl bg-light fw-bolder text-xs text-capitalize">
              Tue 02 Sep 2025
            </span>
          </div>
          <div className="card border border-radius-2xl mb-3">
            <div className="card-body py-3 px-2">
              <p className="mb-1 text-sm text-black">
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quae,
                blanditiis voluptatem. Aspernatur quo dolorem quisquam laborum.
              </p>
              <div className="d-flex align-items-center text-end text-black justify-content-end text-sm opacity-6">
                <i className="bi bi-check2-all text-sm me-1"></i>
                <small>3:14am</small>
              </div>
            </div>
          </div>
          <div className="card border border-radius-2xl mb-3">
            <div className="card-body py-3 px-2">
              <p className="mb-1 text-sm text-black">
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quae,
                blanditiis voluptatem. Aspernatur quo dolorem quisquam laborum.
              </p>
              <div className="d-flex align-items-center text-end text-black justify-content-end text-sm opacity-6">
                <small>3:14am</small>
              </div>
            </div>
          </div>
          <div className="card border border-radius-2xl mb-3">
            <div className="card-header p-2 position-relative z-index-1">
              <div className="d-block">
                <img
                  src="../../assets/img/stores/store-offers-2.jpeg"
                  className="img-fluid border-radius-lg"
                  alt=""
                />
              </div>
            </div>
            <div className="card-body pt-2">
              <p className="mb-1 text-sm text-black">
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quae,
                blanditiis voluptatem. Aspernatur quo dolorem quisquam laborum.
              </p>
              <div className="d-flex align-items-center text-end text-black justify-content-end text-sm opacity-6">
                <small>3:14am</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChannelContent;
